'use client';

import TermsScreen from '@ui/components/screens/TermsScreen/20220902';

const PrivacyPolicyPage = () => {
  return <TermsScreen />;
};

export default PrivacyPolicyPage;
